module.exports = __webpack_public_path__ + "assets/img/coin-top100.58ee29fa.png";